import React from 'react';
import { Modal, SparkIcon, SparkModalPortal, Text } from '@spark';

/**
 * "Your Model will be processed now" (Figma 3001-68567) — shown centered over
 * the Task Page right after a long-running run kicks off: "Let's Train"
 * (default "Training Has Started!" title), or a Revaluate confirm
 * (`title="Revaluate Has Started!"`). "Notify Me" registers the logged-in
 * user's email for a completion email (`onNotifyMe`); when no email is
 * available (e.g. auth disabled) the primary action is a blue "OK" that
 * dismisses. The run continues in the background either way and progress
 * surfaces through the usual task-status updates.
 */
const ModelProcessingModal = ({ open, onClose, onNotifyMe, title = 'Training Has Started!' }) => {
    if (!open) return null;
    const canNotify = Boolean(onNotifyMe);
    return (
        <SparkModalPortal
            open
            onClose={onClose}
            size="slot"
            className="task-processing-modal-portal"
        >
            <Modal
                title={title}
                showSubtitle={false}
                showScrollBar={false}
                showOverlay={false}
                fixedHeight={false}
                showMainButton
                showTertiaryButton={canNotify}
                primaryLabel={canNotify ? 'Notify Me' : 'OK'}
                primaryIcon={
                    canNotify ? <SparkIcon slug="mail" size="medium" /> : undefined
                }
                tertiaryLabel="Got it"
                primaryDisableWhenReadOnly={canNotify}
                onPrimaryClick={canNotify ? onNotifyMe : onClose}
                onTertiaryClick={onClose}
                onCloseClick={onClose}
                className="task-processing-modal"
            >
                <Text
                    variant="base-regular"
                    color="secondary"
                    as="p"
                    className="task-processing-modal__copy"
                >
                    This might take a couple of hours so feel free to grab a coffee (or
                    17) and we will update you once its ready
                </Text>
            </Modal>
        </SparkModalPortal>
    );
};

export default ModelProcessingModal;
